window.ProductItem = {
	calcPrice: function ($item) {
		let price = parseInt($item.find('.price').attr('data-price'));

		$item.find('.additional.vg-dropdown').each(function () {
			if ($(this).data('countable') && $(this).data('multiple')) {
				$(this).find('.dropdown-item').each(function (i, e) {
					price += parseInt($(e).find('.cnt').data('cnt')) * parseInt($(e).data('price'));
				});
			} else {
				$(this).find('.dropdown-item.checked').each(function (i, e) {
					price += parseInt($(e).data('price'));
				});
			}

			let selectedPriceName = $item.find('[data-toggle="click-price"].current').data('price_name');
			if (selectedPriceName) {
				$(this).find('.dropdown-item').each(function (i, di) {
					let prices = String($(di).data('prices')).split(',');
					if (prices.length) {
						$(di).toggleClass('d-none', prices.indexOf(selectedPriceName) === -1);
					}
				});

				let hasVisibleAdditionals = $(this).find('.dropdown-item:not(.d-none)').length > 0;
				$(this).toggleClass('d-none', !hasVisibleAdditionals);
			}
		});

		$item.find('.additional.checkbox').each(function () {
			let $checkbox = $(this).find('[type=checkbox]');
			if ($checkbox.prop('checked')) {
				let priceString = $checkbox.data('price');
				let priceSegments = priceString.split(',');

				let clickPriceIndex = $item.find('[data-toggle=click-price].current').index();
				let checkboxPrice = priceSegments[clickPriceIndex] || price[0];

				price += parseInt(checkboxPrice);
			}
		});

		return price;
	},

	calcPriceProduct: function ($product) {
		let $price = $product.find('.price');
		let price = ProductItem.calcPrice($product);
		$price.find('span').attr('data-price', price).html(output_money(price));
	}
};

$(document).ready(function () {
	$(document).on(
		'click',
		[
			'[data-product-item] .additional .btn-minus',
			'[data-product-item] .additional .btn-plus',
			'[data-product] .additional .btn-minus',
			'[data-product] .additional .btn-plus',
		].join(','),
		function (e) {
			let $counter = $(this).closest('.counter');
			let $cnt = $counter.find('[data-cnt]');
			let oldCnt = parseInt($cnt.data('cnt'));
			let newCnt = $(this).hasClass('btn-minus') ? oldCnt - 1 : oldCnt + 1;
			if (newCnt < 0) newCnt = 0;

			$cnt.text(newCnt).data('cnt', newCnt);

			let $item = $(this).closest('[data-product-item], [data-product]');
			ProductItem.calcPriceProduct($item);

			return false;
		}
	);
	$(document).on(
		'click',
		'[data-product-item] .additional[data-countable="0"] .dropdown-item, [data-product] .additional[data-countable="0"] .dropdown-item',
		function () {
			let $additional = $(this).closest('.additional');

			$(this).toggleClass('checked');

			if (!$additional.data('multiple')) {
				$(this).siblings().removeClass('checked');
			}

			if ($(this).hasClass('checked') && !$additional.data('multiple')) {
				$additional.addClass('no-select');
			} else {
				$additional.removeClass('no-select');
			}

			let $item = $(this).closest('[data-product-item]');
			ProductItem.calcPriceProduct($item);
		}
	);
	$(document).on(
		'click',
		'[data-product-item] .additional, [data-product] .additional',
		function () {
			let $item = $(this).closest('[data-product-item], [data-product]');
			ProductItem.calcPriceProduct($item);
		}
	);
});

$(document).on('modal-loaded', '#modal-prd', function (e) {
	ProductItem.calcPriceProduct(
		$(this).find('[data-product]')
	)
});
